import Absensi from "./absensi";
import BankSoal from "./banksoal";
import AddSoalBankSoal from "./banksoal/add-soal-bs";
import AddSoalCeritaBankSoal from "./banksoal/add-soal-cerita-bs";
import DetailBankSoal from "./banksoal/detail";
import EditSoalBankSoal from "./banksoal/edit-soal-bs";
import EditSoalCeritaBankSoal from "./banksoal/edit-soal-cerita-bs";
import DetailBlog from "./blog/detail-blog";
import Chat from "./chat";
import Course from "./course";
import BuyCourse from "./course/BuyCourse";
import DetailCourse from "./course/DetailCourse";
import Drive from "./drive";
import Faq from "./faq";
import ForgotPass from "./forgot-pass";
import Home from "./home";
import Kalender from "./kalender";
import Kelas from "./kelas";
import DetailKelas from "./kelas/detail";
import Koreksi from "./kelas/koreksi";
import Pembahasan from "./kelas/pembahasan";
import PenilaianTugas from "./kelas/penilaian";
import Library from "./library";
import Login from "./login";
import Notifikasi from "./notifikasi";
import Panduan from "./panduan";
import Pembayaran from "./pembayaran";
import Profile from "./profile";
import Rapor from "./rapor";
import Tugas from "./tugas";
import AddSoal from "./tugas/add-soal";
import EditSoal from "./tugas/edit-soal";
import ImportBankSoal from "./tugas/import-bank-soal";
import LembarTugas from "./tugas/lembar-tugas";
import TugasCourse from "./course/TugasCourse";
import Ujian from "./ujian";
import SoalUjian from "./ujian/soal";
import AddSoalUjian from "./ujian/add-soal";
import EditSoalUjian from "./ujian/edit-soal";
import AddSoalCeritaUjian from "./ujian/add-soal-cerita";
import ImportBankSoalUjian from "./ujian/import-bank-soal";
import PenilaianUjian from "./ujian/penilaian";
import EditSoalCeritaUjian from "./ujian/edit-soal-cerita";
import EditSoalCerita from "./tugas/edit-soal-cerita";
import AddSoalCerita from "./tugas/add-soal-cerita";
import NotFound from "./404";
import KerjakanUjian from "./ujian/kerjakan";
import Loading from "./loading";
import CannotAccess from "./ujian/cannot-access";
export {
  Login,
  Home,
  Kelas,
  DetailKelas,
  PenilaianTugas,
  Kalender,
  Library,
  Drive,
  BankSoal,
  Faq,
  Panduan,
  Pembayaran,
  ForgotPass,
  Koreksi,
  Notifikasi,
  Tugas,
  AddSoal,
  EditSoal,
  Chat,
  DetailBlog,
  LembarTugas,
  Profile,
  Absensi,
  Pembahasan,
  DetailBankSoal,
  AddSoalBankSoal,
  AddSoalCeritaBankSoal,
  EditSoalBankSoal,
  EditSoalCeritaBankSoal,
  ImportBankSoal,
  Course,
  BuyCourse,
  DetailCourse,
  Rapor,
  TugasCourse,
  Ujian,
  SoalUjian,
  AddSoalUjian,
  EditSoalUjian,
  AddSoalCeritaUjian,
  ImportBankSoalUjian,
  AddSoalCerita,
  EditSoalCerita,
  EditSoalCeritaUjian,
  NotFound,
  PenilaianUjian,
  KerjakanUjian,
  CannotAccess,
  Loading,
};
